import { combineEpics } from 'redux-observable';
import { campaignSiteChangeEpic } from './campaign';
import { changeCountryEpic, changeCountryStateEpic, preselectRememberedStateAndCountryEpic } from './countries';
import { addLineItemEpic, addToCartEpic, blinkCartEpic, removeLineItemEpic, resetErrorsEpic } from './items';
import { changeLanguageEpic } from './languages';
import { changeMarketEpic } from './market';
import {
  accountDetailsEpic,
  customerClubEpic,
  logInEpic,
  logOutEpic,
  ordersHistoryEpic,
  passwordChangeEpic,
  passwordRecoveryEpic,
  passwordResetEpic,
  registerEpic,
  registerSuccessEpic } from './membership';
import {
  changePaymentMethodEpic,
  checkIngridDeliveryOptionEpic,
  fetchKCOWidgetEpic,
  handleCheckoutEpic,
  newsletterFieldEpic,
  paymentFieldsEpic,
  paymentResultEpic,
  paymentResultFailureEpic } from './payment';
import { personalIdentityNumberFetchEpic } from './personalIdentityNumber';
import { fetchSelectionEpic } from './selection';
import { changeShippingMethodEpic, handleKlarnaEpic, handleShipwalletStepEpic } from './shipping';
import { changeStepEpic } from './steps';
import { addVoucherEpic, clearVoucherErrorsEpic, removeVoucherEpic } from './voucher';

export default combineEpics(
  addToCartEpic,
  fetchSelectionEpic,
  removeLineItemEpic,
  addLineItemEpic,
  changeStepEpic,
  fetchKCOWidgetEpic,
  handleShipwalletStepEpic,
  changeCountryEpic,
  changeCountryStateEpic,
  changeLanguageEpic,
  changeMarketEpic,
  changeShippingMethodEpic,
  changePaymentMethodEpic,
  paymentResultEpic,
  paymentFieldsEpic,
  paymentResultFailureEpic,
  newsletterFieldEpic,
  blinkCartEpic,
  addVoucherEpic,
  removeVoucherEpic,
  clearVoucherErrorsEpic,
  checkIngridDeliveryOptionEpic,
  handleCheckoutEpic,
  resetErrorsEpic,
  preselectRememberedStateAndCountryEpic,
  logInEpic,
  registerEpic,
  passwordRecoveryEpic,
  passwordResetEpic,
  logOutEpic,
  passwordChangeEpic,
  accountDetailsEpic,
  registerSuccessEpic,
  personalIdentityNumberFetchEpic,
  ordersHistoryEpic,
  customerClubEpic,
  campaignSiteChangeEpic,
  handleKlarnaEpic,
  // changeIngridFieldsStepEpic
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/index.ts